import { ORPCError } from "@orpc/client";
import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { retryUnlessNotFound } from "@packages/core-client/query/retryUnlessNotFound.ts";
import { useQuery } from "@tanstack/react-query";
import { useMatches } from "react-router";
import { useDirectoryClient } from "../../../api/queries/directory.ts";

export function useRenderProfileAsTitleOnly() {
    const matches = useMatches();
    const personId = matches[matches.length - 1]?.params?.personId ?? "";

    const { queryUtils } = useDirectoryClient();
    const { error } = useQuery(
        createQueryOptions(queryUtils.getProfile.queryOptions({ input: { personId } }), {
            throwOnError: false,
            retry: retryUnlessNotFound
        })
    );

    return error instanceof ORPCError && error.code === "NOT_FOUND";
}
